<template>
    <d-form id="kickbiteForm" @submit.prevent="connect">
        <div class="form-group">
            <label>App ID (aid)</label>
            <d-input required v-model="appId" />
        </div>
        <div class="form-group">
            <label>Market ID (mid)</label>
            <d-input required v-model="marketId" />
        </div>
        <d-button theme="success" type="submit">Connect</d-button>
    </d-form>
</template>

<script>
    import { KickbiteIntegration, ErrorService } from '@/main';
    import notification from '@/mixins/notification';
    import * as Sentry from "@sentry/browser"

    export default {
        name: "KickbiteonnectForm",

        props: ['websiteId'],

        mixins: [notification],

        data() {
            return {
                appId: '',
                marketId: '',
            }
        },

        methods: {
            async connect() {
                try {
                    await KickbiteIntegration.connect(
                        this.websiteId,
                        this.appId,
                        this.marketId
                    )

                    this.showNotification('success', 'Alert', 'Kickbite successfully connected!')
                    this.$router.go()
                } catch(e) {
                    this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                    Sentry.captureException(e);
                }
            },
        },
    }
</script>
